import PannelIcon from "../svg/LandingPannel.svg"
const Icon = () => {
    return (
   
  <img src={PannelIcon} />


    )
  }
  export default Icon;